import { useEffect, useState } from 'react'
import { NoRecords, PageLoader } from '../../lib/loader'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { ArrowDown, ArrowUp, Edit, PlusCircle, Search, Trash } from 'lucide-react';
import { Modal, ModalBody } from 'reactstrap';
import AddFaq from './tabs/addFaq';
import EditFaq from './tabs/editFaq';
import { useDeletefaq, useFaqList, useUpdateStatus } from './api/faqapi';
import useConfirm from '../../hooks/useConfirm';
import { useDebounce } from '../../hooks/debounce';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import closecirImg from '../../assets/images/icons/close-circle.svg'
import BreadcrumbPagination from '../../utils/BreadcrumbPagination';
import { useBreadcrumbPagination } from '../../hooks/useBreadcrumbPagination';
function FaqManager() {
    const navigate = useNavigate();
    const [tempPage, setTempPage] = useState(0);
    const [tempRows, setTempRows] = useState(25);
    const [search, setSearch] = useState("");
    const [sortOrder, setSortOrder] = useState("desc")
    const searchText = useDebounce(search)
    const { data: getFaqList, isLoading } = useFaqList({ page: searchText ? 0 : tempPage, size: tempRows, sortOrder: sortOrder, searchText, sortField: '_id' });

    const totalRecords = getFaqList?.data?.count || 0;

    const {
        page,
        rowsPerPage,
        totalPages,
        handleChangePage,
        handleChangeRowsPerPage
    } = useBreadcrumbPagination(totalRecords, tempRows);

    useEffect(() => {
        setTempPage(page);
    }, [page]);

    useEffect(() => {
        setTempRows(rowsPerPage);
    }, [rowsPerPage]);


    const [Dialog, confirmDelete] = useConfirm()
    const deleteFAQ = useDeletefaq();
    const updateFAQStatus = useUpdateStatus()

    const [open, setOpen] = useState(false)
    const toggle = () => setOpen(!open)
    const [openedit, setOpenedit] = useState(false)


    const toggleEdit = () => setOpenedit(!openedit)

    const query = new URLSearchParams(window.location.search);
    const id = query.get('id');

    const handleEdit = (id) => {
        navigate(`?id=${id}`)
        toggleEdit();
    }

    const deletefaq = async (item) => {
        const isConfirmed = await confirmDelete()
        if (isConfirmed) {
            await deleteFAQ.mutateAsync(item);
        }
    }

    const faqStatus = async (item) => {
        const obj = {
            question: item.question,
            answer: item.answer,
            isActive: !item.isActive,
            _id: item._id
        }
        await updateFAQStatus.mutateAsync({ ...obj });
    }

    const list = () => {
        if (isLoading) {
            return <PageLoader />
        }
        else if (getFaqList?.data?.faqs?.length > 0) {
            return <>

                {updateFAQStatus.isLoading || deleteFAQ.isLoading &&
                    <PageLoader />}
                <div style={{ minHeight: "60vh" }}>
                    <div className='table-responsive'>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ maxWidth: "60px" }} align='center'>
                                        S.NO
                                    </TableCell>
                                    <TableCell>Question</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell>Updated Date & Time {sortOrder !== "desc" ? <ArrowUp onClick={() => setSortOrder('desc')} style={{ cursor: "pointer" }} /> : <ArrowDown onClick={() => setSortOrder('asc')} style={{ cursor: "pointer" }} />}</TableCell>
                                    <TableCell align='center'>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {getFaqList?.data?.faqs?.map((row, i) => (
                                    <TableRow key={row._id}>
                                        <TableCell align='center'>{page * rowsPerPage + (i + 1)}</TableCell>
                                        <TableCell>{row.question}</TableCell>
                                        <TableCell>
                                            <div className="form-check form-switch">
                                                <input className="form-check-input"
                                                    type="checkbox"
                                                    role="switch" id="flexSwitchCheckDefault"
                                                    checked={row.isActive}
                                                    onClick={() => faqStatus(row)} />
                                            </div>
                                        </TableCell>
                                        <TableCell>{moment(row.updatedAt).format("DD/MM/YYYY | hh:mm")}</TableCell>
                                        <TableCell align='center'>
                                            <div className='d-flex justify-content-center'>
                                                <Edit className="mx-3" size={20} type='button' onClick={() => handleEdit(row._id)} />
                                                <Trash className="mx-3" size={20} onClick={() => deletefaq(row)} type='button' />
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </div>
                </div>
                <BreadcrumbPagination
                    page={page}
                    rowsPerPage={rowsPerPage}
                    totalPages={totalPages}
                    totalRecords={totalRecords}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                />
            </>
        } else {
            return <NoRecords />
        }

    }

    return (
        <div>
            <h2>FAQ Management</h2>
            <div className="ad_pg_bx bg-white p-4">
                <div className='d-flex justify-content-between align-items-center mb-2'>
                    <div className='col-md-4'>
                        <div className="input-group">
                            <span className="input-group-icon">
                                <Search size={20} color='#aaa9a9' />
                            </span>
                            <input
                                type="text"
                                onChange={(e) => setSearch(e.target.value)}
                                className="form-control"
                                placeholder="Search question"
                            />
                        </div>
                    </div>
                    <button className='btn btn-primary d-flex align-items-center' onClick={toggle}>
                        <PlusCircle size={20} style={{ marginRight: "2px" }} /> Add FAQ
                    </button>
                </div>
                {list()}
            </div>
            <Dialog />
            <Modal isOpen={openedit} toggle={toggleEdit} centered>
                <div className="modal-header">
                    <h1 className="modal-title fs-5">Edit FAQ</h1>
                    <button type="button" className="btn-close" onClick={toggleEdit} aria-label="Close">
                        <img src={closecirImg} alt="close-circle" />
                    </button>
                </div>
                <ModalBody>
                    <EditFaq toggle={toggleEdit} editData={id} />
                </ModalBody>
            </Modal>

            <Modal isOpen={open} toggle={toggle} centered>
                <div className="modal-header">
                    <h1 className="modal-title fs-5">Add FAQ</h1>
                    <button type="button" className="btn-close" onClick={toggle} aria-label="Close">
                        <img src={closecirImg} alt="close-circle" />
                    </button>
                </div>
                <ModalBody>
                    <AddFaq toggle={toggle} />
                </ModalBody>
            </Modal>
        </div>
    )
}

export default FaqManager